import React, { Component } from "react";
import axios from "axios";
import LineDiagram from "./graph/LineDiagram";
import { Utils } from "../Utils";

// Velocity only: QZSS and the BeiDou GEO are TEC-only, see constellations.ts
import {
  VELOCITY_CONSTELLATIONS as CONSTELLATIONS,
  VelocityConstellation as Constellation,
} from "../constellations";

interface Props {
  stationId: any;
}

interface State {
  varionVel: any;
  internvalId: any;
  isStationOffline: boolean;
  constellation: Constellation;
}

class Ground extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      varionVel: [],
      internvalId: null,
      isStationOffline: false,
      constellation: "GPS",
    };
  }

  refreshData() {
    axios
      .get(
        Utils.BACKEND_BASE_URL +
          "station/" +
          this.props.stationId.toLowerCase() +
          "/constellation/" +
          this.state.constellation
      )
      .then((res) => {
        if (typeof res.data == "object") {
          this.setState({ varionVel: res.data, isStationOffline: false });
        } else {
          this.setState({ isStationOffline: true, varionVel: [] });
        }
      })
      .catch(() => {
        this.setState({ isStationOffline: true, varionVel: [] });
      });
  }

  startPolling() {
    this.refreshData();
    let int = setInterval(() => this.refreshData(), 1000);
    this.setState({ internvalId: int });
  }

  stopPolling() {
    if (this.state.internvalId) clearInterval(this.state.internvalId);
  }

  componentDidMount() {
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  handleConstellationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const constellation = e.target.value as Constellation;
    this.stopPolling();
    this.setState({ constellation, varionVel: [], isStationOffline: false }, () => {
      this.startPolling();
    });
  };

  render() {
    const { varionVel, isStationOffline, constellation } = this.state;

    const buildSeries = (key: string) => {
      if (!varionVel || varionVel.length === 0) return null;
      return [
        {
          id: "data",
          color: Utils.LINE_DIAGRAM_COLOR,
          data: varionVel.slice().reverse().map((c: any) => ({ x: c.t, y: c[key] * 100 })),
        },
      ];
    };

    const charts = [
      { key: "est", label: "East" },
      { key: "nord", label: "North" },
      { key: "up", label: "Up" },
    ];

    return (
      <div className="space-y-4">
        {/* Constellation selector */}
        <div className="flex items-center gap-3">
          <label className="text-sm font-semibold text-brand-500">Constellation:</label>
          <select
            value={constellation}
            onChange={this.handleConstellationChange}
            className="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm focus:border-brand-300 focus:ring-1 focus:ring-brand-300 focus:outline-none"
          >
            {CONSTELLATIONS.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>

        {/* Charts */}
        {!isStationOffline && varionVel.length > 0 &&
          charts.map(({ key, label }) => {
            const data = buildSeries(key);
            return (
              <div key={key} className="rounded-xl bg-white shadow-sm border border-gray-100 overflow-hidden">
                <div className="px-4 py-3 border-b border-gray-50">
                  <h6 className="text-sm font-semibold text-brand-500">
                    {label} component velocity ({constellation})
                  </h6>
                </div>
                <div className="p-2">
                  <div className="chart-area">
                    {data && <LineDiagram data={data} />}
                  </div>
                </div>
              </div>
            );
          })}

        {/* Offline */}
        {isStationOffline && (
          <div className="rounded-xl bg-white shadow-sm border border-gray-100 p-6 text-center">
            <p className="text-sm text-gray-400 italic">
              Selected station is offline. Please try with another one.
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default Ground;
